<template>
  <b-modal
    v-model="showModal"
    title="FIRMAR COMPROMISO DE ADELANTO"
    modal-class="modal-primary"
    size="lg"
    hide-footer
    @hidden="$emit('hidden')"
    scrollable
  >
    <b-card class="p-0 border-0 shadow-sm" no-body>
      <div class="doc-viewer-container">
        <iframe
          v-if="adelanto.compromiso"
          :src="
            'https://view.officeapps.live.com/op/embed.aspx?src=' +
            encodeURIComponent(adelanto.compromiso)
          "
          width="100%"
          height="400px"
          frameborder="0"
          allowfullscreen
        >
        </iframe>

        <div v-else class="p-3 text-center text-danger">
          <b-icon
            icon="file-earmark-excel"
            font-scale="2"
            variant="danger"
            class="mb-2"
          />
          <p>No se ha generado el compromiso de adelanto.</p>
        </div>
      </div>
    </b-card>

    <b-row class="d-flex justify-content-start">
      <b-col cols="6">
        <b-form-group label="Compromiso firmado">
          <b-form-file
            v-model="form.compromiso_firmado"
            placeholder="Seleccione un archivo..."
            drop-placeholder="Suelte el archivo aquí..."
            class="w-100"
          ></b-form-file>
        </b-form-group>
      </b-col>
    </b-row>

    <div class="d-flex justify-content-between">
      <b-button variant="outline-primary" @click="downloadCompromiso">
        DESCARGAR
      </b-button>

      <b-button
        :disabled="!form.compromiso_firmado"
        variant="outline-success"
        @click="firmarCompromiso"
      >
        FIRMAR
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import AdelantoSueldoService from "@/views/rrhh/views/payroll/components/adelanto-sueldo/services/adelanto.sueldo.service.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    ToastificationContent,
  },
  props: {
    adelantoId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      showModal: true,
      adelanto: {
        compromiso: null,
      },
      form: {
        compromiso_firmado: null,
      },
    };
  },
  mounted() {
    this.show();
  },
  methods: {
    async show() {
      try {
        this.addPreloader();
        const { data } = await AdelantoSueldoService.show({
          id: this.adelantoId,
        });
        this.adelanto = data;
      } catch (error) {
        this.showErrorSwal();
      } finally {
        this.removePreloader();
      }
    },
    downloadCompromiso() {
      if (!this.adelanto || !this.adelanto.compromiso) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            icon: "AlertCircleIcon",
            variant: "danger",
            text: "No hay un compromiso disponible para descargar.",
          },
        });
        return;
      }
      const url = this.adelanto.compromiso;
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "compromiso_adelanto.docx"); // Puedes personalizar el nombre
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async firmarCompromiso() {
      try {
        this.addPreloader();

        let formData = new FormData();
        formData.append("id_adelanto", this.adelantoId);
        formData.append("compromiso_firmado", this.form.compromiso_firmado);

        const { data } = await AdelantoSueldoService.firmar(formData);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Éxito",
            icon: "CheckIcon",
            variant: "success",
            text: data.message,
          },
        });
        this.$emit("update");
      } catch (error) {
        this.showErrorSwal();
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style scoped>
.doc-viewer-container {
  padding: 1rem;
}
</style>
